export default "__VITE_ASSET__DIK8246p__"